import React from "react";
import "./Whatsapp.css";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const Whatsapp = () => {
  return (
    <div>
<div className="sticky-icons-wp">
  <div className="whatsapp-tooltip">Need a taxi or cab? Message us!</div>
  <Link
    to="https://wa.me/+919765007100?text=Hi,%20I'm%20interested%20in%20booking%20a%20taxi%20or%20cab.%20Please%20provide%20details."
    target="_blank"
    rel="noopener noreferrer"
    className="icon-wp wp"
  >
    <FaWhatsapp />
  </Link>
</div>
    </div>
  );
};

export default Whatsapp;
